import React from "react";
import SideMenu from "../components/SideMenu";
import SearchBar from "../components/SearchBar";
import DisplayLectures from "../views/DisplayLectures";
import useLectureSearch from "../hooks/useLectureSearch";
import useAuth from "../hooks/useAuth";
import { useEffect } from "react";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import AddClass from "../views/AddClass";
const LECTURES = [
    {
        videoUrl: "http://localhost:3000/videoplayback.mp4",
        date: "2021-01-01",
        title: "Lecture 1",
    },
    {
        videoUrl: "http://localhost:3000/videoplayback.mp4",
        date: "2021-01-01",
        title: "Lecture 2",
    },
]
function Dashboard() {
    const { search, setSearch, filteredLectures, clearSearch } = useLectureSearch();
    const [showAddClass, setShowAddClass] = React.useState(false);
    const { hasAccessToken } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const hasAccess = async () => {

            if (!await hasAccessToken()) {
                toast.error("You are not logged in");
                // navigate home while mainting params
                navigate("/");
                
            }

        }
        hasAccess();
    }, []);
    

    return (
        <div className="flex-1 flex">
            {showAddClass && <AddClass onClose={() => setShowAddClass(false)}/>}
            <SideMenu showAddClass={() => setShowAddClass(true)}/>
            <div className="p-12 flex-1 flex-col">
                <h1 className="font-bold text-xl">CS 224n</h1>
            
                <div className="mt-4 max-w-[700px] w-full">
                    <SearchBar setSearch={setSearch} search={search}/>
                </div>
            
                <div className="mt-4">
                    <DisplayLectures videos={LECTURES} filteredLectures={filteredLectures} search={search}/>
                </div>
            </div>
        </div>
    );
}
export default Dashboard;